import { find, register } from '../../../Javascript/Utils'

const component = el => {
  const componentPrefix = el.dataset.componentPrefix
  const overlay = find(`.${componentPrefix}overlay`, el)
  const content = find(`.${componentPrefix}content`, el)
  const safari = find(`.${componentPrefix}browser-safari`, el)
  const browserVersion = find('.browser-version', el)
  const scriptUri = el.dataset.scriptUri

  window.$buoop = {
    required: {
      e: -4,
      f: -3,
      o: -3,
      s: -1,
      c: -3
    },
    insecure: true,
    overlay: overlay,
    api: 2023.8,
    container: content,
    onshow: function (infos) {
      overlay.setAttribute('aria-hidden', false)
      overlay.scrollTop = 0
      document.body.classList.toggle('noscroll', true)
      browserVersion.innerText = ` (${infos.browser.t})`
      browserVersion.style.display = 'inline'

      if (infos.browser.n === 's') {
        safari.style.display = 'inline-block'
      }
    }
  }

  const e = document.createElement('script')
  e.src = scriptUri
  document.body.appendChild(e)
}

register('BrowserUpdateOverlay', component)
